import { isArray, isObject } from 'util';

/**
 * State初期化処理
 *
 * @param state State
 */
export const initializeState = (state: any) => {
	for (const key of Object.keys(state)) {
		// リストの場合、またはリストのレングスが0の場合、該当リストを初期化にする
		if (isArray(state[key]) && state[key].length === 0) {
			state[key] = [];
			continue;
		}
		if (isObject(state[key])) {
			// オブジェクトの場合再帰処理を行う
			state[key] = initializeState(state[key]);
		}
	}
	return state;
};



// WEBPACK FOOTER //
// ./src/utils/Initial.ts